// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"671":"e02e42fb","750":"b42e9bd3"}[chunkId] + ".chunk.css";
};